<template>
    <div class="spinner">
      <span v-if="isUpload" class="spinner__text">{{ uploadText }} file.</span>
      <span v-else class="spinner__text">Just a sec.</span>
      <svg class="spinner__svg" viewBox="0 0 50 50">
        <circle class="spinner__svgPath" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
    </div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    type: String
  },
  data: () => ({
    uploadText: 'Uploading'
  }),
  computed: {
    isUpload () {
      if (this.type === 'upload') {
        return true
      }
    }
  },
  mounted () {
    // TO DO: make this real
    setTimeout(() => {
      this.uploadText = 'Analysing'
    }, 2000)
  }
}
</script>

<style lang="scss">
  .spinner {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-transition: opacity .3s ease;
    transition: opacity .3s ease;
    &__text {
      position: absolute;
      top: 50%;
      left: 50%;
      text-align: center;
      width: 100px;
      margin: -50px 0 0 -50px;
      color: #FFF;
      letter-spacing: 0.05em;
    }
    &__svg {
      animation: rotate 2s linear infinite;
      z-index: 2;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -25px 0 0 -25px;
      width: 50px;
      height: 50px;
    }
    &__svgPath {
      stroke: #435589;
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/SpinnerIcon/spinner.vue